<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="suggestions"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestions">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>
  <div class="card-tools">
    <a
      [routerLink]="['/humanResources']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 1 }"
    >
      Staff
    </a>
    <a
      [routerLink]="['/humanResources/freelancers']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 2 }"
    >
      Freelancers
    </a>
    <a
      [routerLink]="['/humanResources/drivers']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 3 }"
    >
      Driver & +
    </a>
    <a
      [ngClass]="{ 'btn-selected': step === 4 }"
      [routerLink]="['/humanResources/customers']"
      class="btn btn-dark btn-sm btn-new"
    >
      Customers
    </a>
  </div>
  <div class="card">
    <!-- <div class="card-header">
        <div class="card-tools">
          <a
            [routerLink]="['/humanResouerces/personnel/add']"
            class="btn btn-dark btn-sm btn-new"
          >
            Add employee
          </a>
        </div>
      </div> -->

    <!-- staff y freelancers -->
    <div class="card-body" *ngIf="step == 1 || step == 2">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Employee Name</th>
              <th>Role</th>
              <th>Department</th>
              <th class="th__status">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>
                <a
                  *ngIf="hasPerms('/viewprofiles')"
                  [routerLink]="
                    step === 2
                      ? ['/humanResources/freelancers/edit', item._id]
                      : ['/humanResources/personnel/edit', item._id]
                  "
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.user.firstname }}
                  {{ item.user.lastname }}
                </a>

                <a
                  *ngIf="!hasPerms('/viewprofiles')"
                  class="btn btn-link btn-sm p-2 a--personnel text-muted"
                  style="pointer-events: none; cursor: default"
                >
                  {{ item.user.firstname }}
                  {{ item.user.lastname }}
                </a>
              </td>

              <td>{{ item.user.role?.name || "" }}</td>
              <td>{{ item.user.department }}</td>
              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="
                    item.user.status ? 'badge-success' : 'badge-danger'
                  "
                >
                  {{ item.user.status ? "Active" : "Inactive" }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- drivers -->
    <div class="card-body" *ngIf="step == 3">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Employee Name</th>
              <th>Role</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>
                <a
                  *ngIf="hasPerms('/viewprofiles')"
                  [routerLink]="['/drivers/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.firstname }}
                  {{ item.lastname }}
                </a>

                <a
                  *ngIf="!hasPerms('/viewprofiles')"
                  class="btn btn-link btn-sm p-2 a--personnel text-muted"
                  style="pointer-events: none; cursor: default"
                >
                  {{ item.firstname }}
                  {{ item.lastname }}
                </a>
              </td>

              <td>{{ item.role?.name || "" }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- customers -->
    <div class="card-body" *ngIf="step == 4">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Employee Name</th>
              <th>Role</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>
                <a
                  *ngIf="hasPerms('/viewprofiles')"
                  [routerLink]="['/customers/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.firstname }}
                  {{ item.lastname }}
                </a>

                <a
                  *ngIf="!hasPerms('/viewprofiles')"
                  class="btn btn-link btn-sm p-2 a--personnel text-muted"
                  style="pointer-events: none; cursor: default"
                >
                  {{ item.firstname }}
                  {{ item.lastname }}
                </a>
              </td>

              <td>{{ item.role?.name || "" }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
